"use strict";
/**
 * Re-exports commonly used modules:
 * * Exports [`BN`](https://github.com/indutny/bn.js), [`rlp`](https://github.com/ethereumjs/rlp).
 * @packageDocumentation
 */

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.rlp = exports.BN = void 0; // TODO: This can be replaced with a normal ESM import once
// the new major version of the typescript config package
// is released and adopted here.

var BN = require("bn.js");

exports.BN = BN;

var rlp = require("rlp");

exports.rlp = rlp;